import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";

export const Route = createFileRoute("/_admin/admin/")({
  head: () => pageHead("Admin", "AKIVA admin portal.", "/admin", true),
  component: AdminDashboardPage,
});
